module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZNA98G/tc-custom/9781035813582.jpg?1705539731656",
      "alt": "This image is the cover for the book Calm Pond"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Calm Pond\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Are you looking for the ideal bedtime book for your child? A book where you and your child can connect to strong characters and develop essential life skills through fun? Then look no further than Calm Pond! Calm Pond is in Blackstone Edge. Itis a wonderful place, a special place. It can be quiet and beautiful, but it can also be noisy and fun as it is the home of some amazing creatures! The creatures of Calm Pond live and work together, helping each other to form a strong community. The nine short stories cover many topics to help children understand many life issues, such as equality, resilience, honesty, change, strengths and weaknesses, anxiety, differences, empathy, and bereavement. Calm Pond – educating and entertaining!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Richard Clarke\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Richard Clarke was born in 1969, a proud Bradfordian. A trained PE teacher at Carnegie College, Leeds, he spent nearly 30 years in the education sector. The majority of his experience was as Head of Pastoral at a large secondary school in Halifax.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0